import { render } from "./MultipaneContainer.vue?vue&type=template&id=03d71fb5"
import script from "./MultipaneContainer.vue?vue&type=script&lang=js"
export * from "./MultipaneContainer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__